import CONFIG from '../../config.json';
import { utils } from '../utils';

import type { NETWORK } from '../types';

export const isEnabled = (network: NETWORK): boolean => {
  return utils.getChainType(network) === CONFIG.wormhole.network.toLowerCase();
};
